import Modal from "react-modal";
import React from "react";
import {X} from "react-feather";
import TextInput from "../../../components/Formik/TextInput";
import {useFormik} from "formik";
import * as Yup from "yup";
import TextArea from "../../../components/Formik/TextArea";
import DateTimePicker from "../../../components/Formik/DateTimePicker";
import UploadMultipleImages from "../../../components/Formik/UploadMultipleImages";
import SelectVendor from "../../../components/Formik/SelectVendor";
import {addMAVData, updateMAVData} from "../../../services/api/admin";
import LogoAvatar from "../../../components/Item/LogoAvatar";
import UploadImage from "../../../components/Formik/UploadImage";
import ProductSearch from "../../../components/Input/ProductSearch";
import PresenterForm from "../../../components/Mav/PresenterForm";

const AddEditModal = ({data = null, onClose, fetchMAVRecords}) => {


    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [hasImageChanges, setHasImageChanges] = React.useState(false);
    const [selectedVendor, setSelectedVendor] = React.useState(data?.vendor ? data.vendor : null);
    const [selectedProducts, setSelectedProducts] = React.useState(data?.products ? data.products : []);
    const [presenters, setPresenters] = React.useState(data?.presenters ? data.presenters : []);

    const formik = useFormik({
        initialValues: {
            start_datetime: null,
            end_datetime: null,
            title: '',
            products: [],
            featured_image: null,
            description: '',
            video_link: '',
            registration_link: '',
            is_vendor_invite: false,
            images: [],
            vendor_id: null,
            presenters: [],
            ...data ? data : {}

        },
        validationSchema: Yup.object().shape({
            title: Yup.string().required('Title is required').max(200, 'Max 200 characters'),
            products: Yup.array().min(1, 'At least one product must be selected.'),
            start_datetime: Yup.date().required('Start date is required'),
            end_datetime: Yup.date().required('End date is required')
                .min(Yup.ref('start_datetime'), 'End date must be after the start date'),
            description: Yup.string().nullable().max(255, 'Max 255 characters'),
            vendor_id: Yup.string().required('Vendor is required'),
            video_link: Yup.string().nullable().url('The video link field must be a valid URL.'),
            registration_link: Yup.string().nullable().url('The registration link field must be a valid URL.'),
            presenters: Yup.array()
                .of(
                    Yup.object().shape({
                        name: Yup.string().max(100, 'Max 100 characters.'),
                        title: Yup.string().max(100, 'Max 100 characters.'),
                    })
                ),
        }),
        onSubmit: async (values) => {
            try {
                values['presenters'] = formik.values.presenters.filter(
                    presenter => presenter.name.trim() !== '' || presenter.title.trim() !== '' || presenter.photo !== null
                );
                values['products'] = selectedProducts.map(product => product.id);
                setIsSubmitting(true);
                //if data is set call edit api
                if (data?.id) {
                    await updateMAVData(data.id, values);
                } else
                    //else call add api
                    await addMAVData(values);

                await fetchMAVRecords();
                setIsSubmitting(false);
                onModalClose()
            } catch (e) {
                setIsSubmitting(false);
                console.log('error', e)
            }
        },
    });

    const handleProductSelect = (product) => {
        if (selectedProducts.length < 3) {
            const updatedSelectedProducts = [...selectedProducts, {name: product.name, id: product.id}];
            setSelectedProducts(updatedSelectedProducts);
            formik.setFieldValue('products', updatedSelectedProducts.map(product => product.id));
        }
    };

    const handleProductRemove = (productId) => {
        const updatedSelectedProducts = selectedProducts.filter(p => p.id !== productId);
        setSelectedProducts(updatedSelectedProducts);
        formik.setFieldValue('products', updatedSelectedProducts.map(product => product.id));
    };

    const addPresenter = () => {
        if (presenters.length < 4) {
            const currentPresenters = formik.values.presenters;
            const updatedPresenters = [...currentPresenters, { id: Date.now(), name: '', title: '', photo: null }];
            setPresenters(updatedPresenters);
            formik.setFieldValue('presenters', updatedPresenters);
        }
    };

    const removePresenter = (index) => {
        const updatedPresenters = formik.values.presenters.filter((_, idx) => idx !== index);
        setPresenters(updatedPresenters);
        formik.setFieldValue('presenters', updatedPresenters);
    };

    const onImageDelete = async (item, value) => {
        try {
            if (data?.id) {
                if (Array.isArray(data.products) && typeof data.products[0] === 'object') {
                    data.products = data.products.map(product => product.id);
                }
                if (item === 'presenters') {
                    data[item][value.index] = value.presenter;
                } else {
                    data[item] = value;
                }
                await updateMAVData(data.id, data);
                setHasImageChanges(true);
            }
        } catch (e) {
            console.log(e)
        }
    }

    const onModalClose = async () => {
        try {
            if (hasImageChanges)
                await fetchMAVRecords();
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            onClose();
        } catch (e) {
            console.log(e)
        }
    }


    return <Modal
        isOpen={true}
        className="sl-modal-content sl-max-modal"
        overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">
        <div className="sl-modal-body">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title"
                     className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    {data ? 'Edit' : 'Add New'}
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0">
                    <X onClick={onModalClose}/>
                </div>
            </div>
            <div className="sl-modal-body">
                <div
                    className="sl-modal-body sl-max-h-162 sl-h-auto sl-px-6 sl-pb-10 sl-pt-24 sl-overflow-y-auto sl-customized-scrollbar">
                    <div className="sl-display-flex sl-flex-col sl-width-100 sl-gap-8">
                        {!selectedVendor &&
                            <SelectVendor formik={formik} label={'Select Vendor'} name={'vendor_id'}
                                          setSelectedVendor={setSelectedVendor}/>}

                        {selectedVendor && <div className={"sl-relative sl-flex sl-gap-2"}>
                            <LogoAvatar slug={selectedVendor.slug} logo={selectedVendor.favico}
                                        avatarClass="sl-h-6 sl-w-6"/>

                            <div className={"sl-absolute sl-right-0 sl-cursor-pointer sl-top-0"}>
                                <X onClick={() => {
                                    setSelectedVendor(null);
                                    formik.handleChange({
                                        target: {name: 'vendor_id', value: null}
                                    })

                                }}/>
                            </div>
                            {selectedVendor.name}
                        </div>}

                        <TextInput formik={formik} label={'Title'} name={'title'}/>

                        <ProductSearch
                            formik={formik}
                            name={'products'}
                            label={'Select Products'}
                            selectedProducts={selectedProducts}
                            onProductSelect={handleProductSelect}
                            onProductRemove={handleProductRemove}
                        />

                        <div className={`sl-flex sl-gap-1 sl-justify-space-between`}>
                            <DateTimePicker formik={formik} label={'Start'} name={'start_datetime'}/>
                            <DateTimePicker formik={formik} label={'End'} name={'end_datetime'}/>
                        </div>

                        <div className="sl-mb-4">
                            <div
                                className="sl-mb-2 sl-font sl-font-medium sl-text-sm sl-text-gray-700"
                                dangerouslySetInnerHTML={{__html: "Presenters"}}
                            />
                            {presenters.map((presenter, index) => (
                                <PresenterForm
                                    key={presenter.id}
                                    index={index}
                                    formik={formik}
                                    removePresenter={removePresenter}
                                    onImageDelete={onImageDelete}
                                />
                            ))}
                            {presenters.length < 4 && (
                                <button
                                    onClick={addPresenter}
                                    className="sl-btn sl-btn-primary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font "
                                >
                                    Add Presenter
                                </button>
                            )}
                        </div>

                        <UploadImage onImageDelete={onImageDelete} formik={formik} label={'Featured Image'} name={'featured_image'}/>
                        <UploadMultipleImages onImageDelete={onImageDelete} formik={formik} label={'Select Uploads'}
                                              name={'images'}/>
                        <TextInput formik={formik} label={'Video Link'} name={'video_link'}/>
                        <TextInput formik={formik} label={'Registration Link'} name={'registration_link'}/>
                        <label className="sl-flex sl-items-center sl-gap-2 sl-cursor-pointer sl-mt-2">
                            <input
                                type="checkbox"
                                name="is_vendor_invite"
                                checked={!!formik.values.is_vendor_invite}
                                onChange={(e) => formik.setFieldValue('is_vendor_invite', e.target.checked)}
                            />
                            <span className="sl-font sl-text-sm sl-text-gray-700">Vendor-only webinar (shown to vendors at login, hidden from brokers)</span>
                        </label>
                        <TextArea labelClasses={"sl-font sl-font-medium sl-text-sm sl-text-gray-700"} formik={formik}
                                  label={'Description'} name={'description'}/>
                    </div>
                </div>

            </div>
            <div className="sl-modal-footer sl-px-6 sl-py-32  sl-display-flex sl-flex-row sl-justify-space-between">

                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5
                             sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button
                        onClick={onModalClose}
                        className="sl-btn sl-btn-tertiary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font">
                        Cancel
                    </button>
                </div>

                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button
                        disabled={isSubmitting}
                        onClick={formik.submitForm}
                        className="sl-btn sl-btn-primary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font ">
                        {isSubmitting ? <div className="sl-loader sl-m-auto sl-w-6 sl-h-6"/> : 'Save'}
                    </button>
                </div>

            </div>
        </div>
    </Modal>
}

export default AddEditModal;
